<template>
  <div v-if="isMobile" class="featured-events-wrapper">
    <div class="row d-flex justify-content-center col-12">
      <div class="col-10 col-md-8 featured-event-card-mobile"
        v-for="(event) in featuredEventsLocations.slice(startIndex, endIndex + 1)" :key="event.name">
        <router-link :to="getEventLink(event)" class="wrapper-content-right">
          <img :src="event.imageUrl" :alt="event.imageAlt" role="presentation" class="img-hover" />
          <div class="event-hero">
            <h3>{{ event.title }}</h3>
            <span class="experience-city">{{ event.city }}, AL</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row d-flex col-12 justify-content-center pt-3">
      <div class="d-flex col-6 justify-content-end">
        <img @click="prevEvent(); paginate(-1)" src="/images/icons/chevron.svg" alt="arrow-left"
          class="featured-events-arrow-left" :class="{ disableBtn: currentIndex === 0 }"
          :disabled="currentPage === 0" />
      </div>
      <div class="d-flex col-6 justify-content-start">
        <img @click="nextEvent(); paginate(1)" src="/images/icons/chevron.svg" alt="arrow-right"
          class="featured-events-arrow-right"
          :class="{ disableBtn: this.endIndex >= featuredEventsLocations.length - 1 }"
          :disabled="currentPage === featuredEventsLocations.length - 1" />
      </div>
    </div>
  </div>
  <div v-else class="row featured-events-wrapper">
    <div class="col-lg-1 prev-btn">
      <img @click="prevEvent" src="/images/icons/chevron.svg" alt="arrow-left" class="featured-events-arrow-left"
        :class="{ disableBtn: currentIndex === 0 }" />
    </div>
    <div
      v-if="featuredEventsLocations && featuredEventsLocations[featuredEventIndex] && featuredEventsLocations[featuredEventIndex].slug"
      class="col-lg-5 col-md-12 featured-event-card">
      <router-link :to="getEventLink(featuredEventsLocations[featuredEventIndex])" class="wrapper-content">
        <img :src="featuredEventsLocations[featuredEventIndex].imageUrl"
          :alt="featuredEventsLocations[featuredEventIndex].imageAlt" role="presentation" class="event-hero-image" />
        <div class="event-hero">
          <h3 class="event-hero-hd justify-content-center">
            {{ featuredEventsLocations[featuredEventIndex].title }}
          </h3>
          <span class="experience-city">{{ featuredEventsLocations[featuredEventIndex].city }}, AL</span>
        </div>
      </router-link>
    </div>
    <div class="col-lg-5 featured-event-card">
      <div v-if="featuredEventsLocations && featuredEventsLocationsMinusFirstOne" class="row col-lg-12 featured-event-card">
        <div class="col-sm-12 col-lg-6"
          v-for="(event) in featuredEventsLocationsMinusFirstOne.slice(startIndex, endIndex)" :key="event.title">
          <router-link :to="getEventLink(event)" class="wrapper-content-right">
            <img :src="event.imageUrl" :alt="event.imageAlt" role="presentation" class="img-hover" />
            <div class="event-hero">
              <h3>{{ event.title }}</h3>
              <span class="experience-city">{{ event.city }}, AL</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="col-lg-1 next-btn">
      <img @click="nextEvent" src="/images/icons/chevron.svg" alt="arrow-right" class="featured-events-arrow-right"
        :class="{ disableBtn: this.endIndex >= featuredEventsLocations.length - 1 }" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    featuredEventsLocations: {
      type: Array,
      required: true,
    },
    featuredEventsLocationsMinusFirstOne: {
      type: Array,
      // required: true,
    },
  },
  data() {
    return {
      isMobile: window.innerWidth < 930,
      currentIndex: 0,
      featuredEventIndex: 0,
      startIndex: 0,
      endIndex: 4,
      currentPage: 0,
    };
  },
  created() {
    window.addEventListener('resize', this.mq);
  },
  methods: {
    mq() {
      this.width = document.documentElement.clientWidth;
      this.isMobile = this.width < 930;
    },
    getEventLink(event) {
      return event.slug.includes('/places-to-go') ? event.slug : `/upcoming-events/${event.slug}`;
    },
    incrementValue(value, limit, increment) {
      if (value < limit) {
        return value + increment;
      }
      return value;
    },
    nextEvent() {
      this.currentIndex = this.incrementValue(this.currentIndex, this.featuredEventsLocations.length - 1, 1);
      this.featuredEventIndex = this.incrementValue(this.featuredEventIndex, this.featuredEventsLocations.length - 1, 5);
      this.startIndex = this.incrementValue(this.startIndex, this.featuredEventsLocationsMinusFirstOne.length - 4, 5);
      this.endIndex = this.incrementValue(this.endIndex, this.featuredEventsLocationsMinusFirstOne.length, 5);
    },
    decrementValue(value, limit, decrement) {
      if (value >= limit) {
        return value - decrement;
      }
      return value;
    },
    prevEvent() {
      this.currentIndex = this.decrementValue(this.currentIndex, 1, 1);
      this.featuredEventIndex = this.decrementValue(this.featuredEventIndex, 5, 5);
      this.startIndex = this.decrementValue(this.startIndex, 5, 5);
      this.endIndex = this.decrementValue(this.endIndex, 9, 5);
    },
    paginate(direction) {
      this.currentPage += direction;
      // Scroll to the top of the current section
      this.scrollToSection();
    },
    scrollToSection() {
      const sectionElement = this.$el.querySelectorAll('div')[this.currentPage];
      sectionElement.scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
.featured-events-wrapper {
  width: 100vw;

  @media only screen and (min-width: 769px) {
    width: 95vw;
    margin: 40px 40px;
  }
}

.featured-event-card-mobile {
  padding-right: 30px !important;
}

.featured-event-card {
  padding: 0 !important;
}

h3 {
  color: #ffffff;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.31);
  margin: 10px 30px;
}

a {
  display: block;
  color: #ffffff;
}

a:hover {
  text-decoration: none;
}

.event-hero-hd {
  font-size: 42px;
}

.event-label {
  margin-bottom: 15px;
}

.experience-city {
  background-color: #ffffff;
  border-radius: 4px;
  color: #2c3e50;
  font-size: small;
  padding: 5px 10px;
}

.event-hero-image {
  min-height: 480px;
  width: 100%;
  transform: scale(1);
  transition: all 300ms ease-in-out;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
}

.event-hero {
  position: absolute;
  z-index: 2;
  bottom: 15px;
  width: 100%;
}

.wrapper-content {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  max-height: 465px;
  max-width: 100%;
  overflow: hidden;
  transform: scale(1);
  transition: all 300ms ease-in-out;
  border-radius: 5px;
  width: 100%;

  @media only screen and (max-width: 768px) {
    max-width: 92%;
  }
}

.wrapper-content-right {
  display: flex;
  justify-content: center;
  max-height: 220px;
  max-width: 282px;
  overflow: hidden;
  transform: scale(1);
  transition: all 300ms ease-in-out;
  border-radius: 5px;
  margin-bottom: 15px;
  height: 240px;
  max-width: 100%;
  width: 100%;

  @media only screen and (max-width: 767px) {
    margin: 25px auto 0;
    width: 100%;
    min-width: 109%;
  }

  @media only screen and (min-width: 768px) {
    margin-bottom: 0;
    margin-top: 25px;
    margin-left: 15px;
  }

  @media only screen and (min-width: 1400px) {
    margin-bottom: 0;
    margin-top: 25px;
  }
}

.img-hover {
  height: 240px;
  transform: scale(1);
  transition: all 300ms ease-in-out;
  width: 302.5px;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  @media only screen and (min-width: 769px) {
    width: 100%;
  }
}

.wrapper-content:hover .event-hero-image {
  transform: scale(1.1);
  transition: all 1s ease-in-out;
}

.wrapper-content-right:hover .img-hover {
  transform: scale(1.1);
  transition: all 1s ease-in-out;
}

.exp-mt {
  margin-top: 120px;
}

.prev-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 15px !important;
}

.next-btn {
  display: flex;
  align-items: center;
  padding: 0 !important;
}

.featured-events-arrow-left {
  transform: rotate(-90deg);
  margin-top: 25px;
}

.featured-events-arrow-right {
  transform: rotate(90deg);
  margin-top: 25px;
}

.featured-events-arrow-left:hover, .featured-events-arrow-right:hover {
  cursor: pointer;
  filter: brightness(0) saturate(100%) invert(16%) sepia(39%) saturate(798%) hue-rotate(150deg) brightness(95%) contrast(90%);
}

.disableBtn {
  opacity: 0;
  pointer-events: none;
}
</style>
